export const msalConfig = {
  auth: {
    clientId: "8d5e30f0-919d-48c0-9bef-226d26c27bed",
    authority:
      "https://login.microsoftonline.com/86ca241a-62ce-49f5-9bc2-7a0fe90ab77e",
    redirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false,
  },
};

export const loginRequest = {
  scopes: ["User.Read", "Group.Read.All"],
  forceRefresh: true,
};

export const graphConfig = {
  graphMeEndpoint: "https://graph.microsoft.com/v1.0/me",
};
